import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
// import { Component } from "react";
import UTILS from "../utils/commons";
import Login from "./home/login_form";
import Dashboard from "./home/dashboard";
import SignupForm from "./home/signup_form";
import StaffForm from "./staff/staff_form";
import NotFound from "./home/404";
import ProductForm from "./products/product_form";
import ProductList from "./products/products";
import ProductDetail from "./products/product_detail";
import ProductEditForm from "./products/product_edit_form";
import StaffDetail from "./staff/staff_detail";
import StaffEditForm from "./staff/staff_edit_form";
import SupplierList from "./suppliers/suppliers";
import SupplierDetail from "./suppliers/supplier_detail";
import SupplierForm from "./suppliers/supplier_form";
import SupplierEditForm from "./suppliers/supplier_edit_form";
import Inventory from "./inventory/inventory";
import ReceiveInventory from "./inventory/receive_inventory";
import IssueInventory from "./inventory/issue_inventory";
import Customers from "./customers/customers";
import CustomerForm from "./customers/customer_form";
import CustomerEditForm from "./customers/customer_edit_form";
import CustomerDetail from "./customers/customer_details";
import Report from "./reports/report";
import SaleForm from "./staff/sale_form";
import Settings from "./home/settings";
import Help from "./home/help";
import PasswordResetForm from "./home/password_reset";
import InventoryDetail from "./inventory/inventory_detail";
import Payments from "./payments/payments";
import PaymentForm from "./payments/payment_form";
import TransactionList from "./transactions/transactions";
import TransactionDetail from "./transactions/transaction_detail";
import Staff from "./staff/staff";
import TransactionForm from "./transactions/transaction_form";
import Expenses from "./expenses/expenses";
import ExpenseForm from "./expenses/expense_form";
import ExpenseDetail from "./expenses/expense_detail";
import Tenders from "./tenders/tenders";
import TenderForm from "./tenders/tender_form";
import TenderDetails from "./tenders/tender_detail";
import TenderEditForm from "./tenders/tender_edit_form";

const getRole = () => {
  try {
    const raw = window.sessionStorage.getItem( "loginState" );
    if ( !raw ) return null;
    return JSON.parse( raw )?.role || null;
  } catch {
    return null;
  }
};

const UnauthorizedAccessModal = ( { onContinue } ) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-5 shadow-xl">
        <p className="text-sm uppercase tracking-wide text-red-500">Access Restricted</p>
        <p className="text-xl font-semibold text-gray-800 mt-1">Not Authorized</p>
        <p className="text-sm text-gray-600 mt-3">
          You are not authorized to access this part of the app.
        </p>
        <div className="mt-5 flex justify-end">
          <button
            className="px-4 py-2 rounded-md bg-primary-500 text-white hover:opacity-90"
            onClick={onContinue}
            type="button"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

const RoleGuard = ( { allowedRoles, children } ) => {
  const role = getRole();
  const navigate = useNavigate();
  if ( !role ) return <Navigate to="/signin" replace />;
  if ( !allowedRoles || allowedRoles.includes( role ) ) return children;

  return <UnauthorizedAccessModal onContinue={() => navigate( "/dashboard", { replace: true } )} />;
};

class CustomRouter extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signin" element={<Login />} />
          <Route path="/signup" element={<SignupForm />} />
          <Route
            path="/dashboard" element={<Dashboard />}
          />
          <Route
            path="/reports" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><Report /></RoleGuard>}
          />
          <Route
            path="/staff" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><Staff /></RoleGuard>}
          />
          <Route
            path="/staff/new" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><StaffForm /></RoleGuard>}
          />
          <Route
            path="/staff/view/:id" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><StaffDetail /></RoleGuard>}
          />
          <Route
            path="/staff/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><StaffEditForm /></RoleGuard>}
          />
          <Route
            path="/customers" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><Customers /></RoleGuard>}
          />
          <Route
            path="/customers/new" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.ADMIN ]}><CustomerForm /></RoleGuard>}
          />
          <Route
            path="/customers/view/:id" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><CustomerDetail /></RoleGuard>}
          />
          <Route
            path="/customers/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.ADMIN ]}><CustomerEditForm /></RoleGuard>}
          />

          <Route
            path="/suppliers/new" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><SupplierForm /></RoleGuard>}
          />
          <Route
            path="/suppliers/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><SupplierEditForm /></RoleGuard>}
          />
          <Route
            path="/suppliers/view/:id" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><SupplierDetail /></RoleGuard>}
          /> <Route
            path="/suppliers" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><SupplierList /></RoleGuard>}
          />
          <Route
            path="/inventory/view/:id" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><InventoryDetail /></RoleGuard>}
          />
          <Route
            path="/inventory/receive" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><ReceiveInventory /></RoleGuard>}
          />
          <Route
            path="/inventory/issue" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><IssueInventory /></RoleGuard>}
          />
          <Route
            path="/inventory" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><Inventory /></RoleGuard>}
          />
          <Route path="/signout" element={<Login />} />
          <Route path="/reset" element={<PasswordResetForm />} />
          <Route path="/products" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><ProductList /></RoleGuard>} />
          <Route path="/products/new" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><ProductForm /></RoleGuard>} />
          <Route path="/products/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><ProductEditForm /></RoleGuard>} />
          <Route path="/products/view/:id" element={<RoleGuard allowedRoles={[ UTILS.ADMIN ]}><ProductDetail /></RoleGuard>} />
          <Route path="/sales" element={<RoleGuard allowedRoles={[ UTILS.SALES ]}><SaleForm /></RoleGuard>} />
          <Route path="/settings" element={<RoleGuard allowedRoles={[ UTILS.STAFF, UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><Settings /></RoleGuard>} />
          <Route path="/help" element={<Help />} />

          <Route
            path="/payments/new" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><PaymentForm /></RoleGuard>}
          /> <Route
            path="/payments" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><Payments /></RoleGuard>}
          />
          <Route path="/payments/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><PaymentForm /></RoleGuard>} />
          <Route path="/payments/view/:id" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><PaymentForm /></RoleGuard>} />
          <Route path="/expenses/new" element={<RoleGuard allowedRoles={[ UTILS.STAFF, UTILS.SALES, UTILS.ADMIN ]}><ExpenseForm /></RoleGuard>} />
          <Route path="/expenses" element={<RoleGuard allowedRoles={[ UTILS.STAFF, UTILS.SALES, UTILS.ADMIN ]}><Expenses /></RoleGuard>} />
          <Route path="/expenses/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.STAFF, UTILS.SALES, UTILS.ADMIN ]}><ExpenseForm /></RoleGuard>} />
          <Route path="/expenses/view/:id" element={<RoleGuard allowedRoles={[ UTILS.STAFF, UTILS.SALES, UTILS.ADMIN ]}><ExpenseDetail /></RoleGuard>} />

          <Route
            path="/transactions" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><TransactionList /></RoleGuard>}
          />
          <Route
            path="/transactions/new" element={<RoleGuard allowedRoles={[ UTILS.SALES ]}><TransactionForm /></RoleGuard>}
          />
          <Route
            path="/transactions/view/:id" element={<RoleGuard allowedRoles={[ UTILS.SALES, UTILS.FINANCE, UTILS.ADMIN ]}><TransactionDetail /></RoleGuard>}
          />
          <Route path="/tenders" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><Tenders /></RoleGuard>} />
          <Route path="/tenders/new" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><TenderForm /></RoleGuard>} />
          <Route path="/tenders/view/:id" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><TenderDetails /></RoleGuard>} />
          <Route path="/tenders/edit/:id" element={<RoleGuard allowedRoles={[ UTILS.FINANCE, UTILS.ADMIN ]}><TenderEditForm /></RoleGuard>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    );
  }
}
export default CustomRouter;
